import { useQuery } from '@apollo/client';
import { GET_USER_PREFERENCES } from '../../graphql/queries/user/user';

const useGetUserPreferences = () => {
  const { data, loading, error } = useQuery(GET_USER_PREFERENCES);

  return { data, loading, error };
};

export default useGetUserPreferences;
